<template>
  <section class="equipment-header" :class="{ 'has-extra': $slots.extra }">
    <span class="left heading-2">
      <slot name="title">DEFAULT TITLE</slot>
    </span>
    <span v-if="$slots.extra" class="extra"><slot name="extra"></slot></span>

    <span v-if="$slots.titleRight" class="right">
      <slot name="titleRight"></slot>
    </span>
  </section>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.equipment-header {
  display: grid;
  gap: 1em;
  grid-template-columns: minmax(20px, max-content) minmax(6em, 1fr);
  align-items: center;
  .extra {
    display: grid;
    gap: 0.5em;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
  .right {
    gap: 0.5em;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(80px, max-content));
    align-items: center;
    justify-content: end;
  }
  &.has-extra {
    grid-template-columns: max-content minmax(220px, 1fr) 1fr;
  }
}
@media only screen and (max-width: 750px) {
  .equipment-header {
    .right {
      grid-template-columns: none;
    }
  }
}
</style>
